import React, { useContext } from 'react';
import { HopeGlobalContext } from '@mummssoftware/global-context';
import { getCurrentMilestone, milestones } from '@mummssoftware/utils/hope';
import { HopeVisitWrapper } from './HOPEWrappers';
import defaults from '../../translations/en.json';

export const HopeVisitContent = () => {
  const { availableHOPEActions } = useContext(HopeGlobalContext);
  const currentMilestone = getCurrentMilestone(availableHOPEActions);
  const isSFV = currentMilestone?.includes('-SFV');
  const selector: string = isSFV ? 'SFV' : currentMilestone || '';
  const displayMessage = (milestones as any)[selector];
  return (
    <HopeVisitWrapper>
      <>{`${defaults.HopeVisitIntro} ${displayMessage}?`}</>
    </HopeVisitWrapper>
  );
};
